import { IContext } from "@src/context";
import { isTimeInRange } from "@src/utils/timeInRange";

// TODO: will change to prototype from API
interface IThankYouPageNotice {
  enabled: boolean;
  noticeStartAt: string;
  noticeEndAt: string;
  notice: {
    en: string;
    ja: string;
    pt: string;
    vi: string;
    zh: string;
    my: string;
    id: string;
    ne: string;
  };
}

export function setThankYouPageNotice(
  context: IContext,
  data: IThankYouPageNotice
) {
  const container = document.querySelector(".container-thank-you");
  if (container) {
    const { locale } = context;
    const { enabled, noticeStartAt, noticeEndAt, notice } = data;
    if (enabled && isTimeInRange(noticeStartAt, noticeEndAt)) {
      container
        .querySelector(".container-thank-you-link")
        ?.insertAdjacentHTML(
          "beforebegin",
          `<div class="container-thank-you-notice">${notice[locale]}</div>`
        );
    }
  }
}
